import { render, staticRenderFns } from "./ConsumptionCategory.vue?vue&type=template&id=3fcfdeda"
import script from "./ConsumptionCategory.vue?vue&type=script&lang=js"
export * from "./ConsumptionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports